import { render, staticRenderFns } from "./productCertificate.vue?vue&type=template&id=dac3ac50&scoped=true"
import script from "./productCertificate.vue?vue&type=script&lang=js"
export * from "./productCertificate.vue?vue&type=script&lang=js"
import style0 from "./productCertificate.vue?vue&type=style&index=0&id=dac3ac50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac3ac50",
  null
  
)

export default component.exports